import { render, staticRenderFns } from "./SimpleSignSAgile.vue?vue&type=template&id=63b49e7a&"
import script from "./SimpleSignSAgile.vue?vue&type=script&lang=js&"
export * from "./SimpleSignSAgile.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSignSAgile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b49e7a')) {
      api.createRecord('63b49e7a', component.options)
    } else {
      api.reload('63b49e7a', component.options)
    }
    module.hot.accept("./SimpleSignSAgile.vue?vue&type=template&id=63b49e7a&", function () {
      api.rerender('63b49e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/agile/SimpleSignSAgile.vue"
export default component.exports